'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg12 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 12, height: 13, viewBox: "0 0 12 13", fill: "none" }, props),
    React__namespace.createElement("g", { clipPath: "url(#12_svg__clip0_39877_64187)" },
        React__namespace.createElement("path", { d: "M4.785 2.753a.7.7 0 1 1 .955 1.023L3.291 6.062l-.249.233h7.528a.7.7 0 1 1 0 1.4H3.006l.285.268 2.418 2.256a.7.7 0 1 1-.956 1.023l-2.45-2.286c-.339-.317-.644-.602-.858-.865-.234-.287-.432-.635-.432-1.079s.198-.791.432-1.079c.214-.263.52-.548.859-.864z", fill: props.fillColor, fillOpacity: 0.92 })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "12_svg__clip0_39877_64187" },
            React__namespace.createElement("rect", { width: 11.995, height: 11.995, fill: "white", transform: "translate(0 .997)" })))));

exports.default = Svg12;
//# sourceMappingURL=12.js.map
